import { ID, TypeParams } from "../../features/core/utils";

export interface HarvestRanchComparative {
    id: number,
    name: string,
    area: number,
    start_date: string | null,
    days_worked: number,
    end_date: string | null,
    harvested_area: number,
    humidity: number,
    performance: number,
    total_points: number,
    progress: number
}

export interface PerHumTooltip {
    telemetry_points: null | number, // N° puntos (telemetria)      
    telemetry: null | number,        // Mediana (telemetria)           
    telemetry_std: null | number,    // Desviacion estandar (telemetria)
    csv_points: null | number,       // N° puntos csv                
    csv: null | number,              // Mediana csv                   
    csv_std: null | number           // Desviacion estandar CSV    
}

export interface ranchsCropTypeBulk {
    [TypeParams.RANCH_IDS]: number[],
    [TypeParams.CROP_TYPE]: number,
    [TypeParams.RANCH_TYPE]: number
}

export type editableHarvestField = number | null

export enum HarvestRanchFieldTypes {
   satelital = "satelital",
   manual = 'manual',
   telematic = 'telematic'
}

export const ManualHarvestRanchValue = 0;
export const TelematicHarvestRanchValue = 1;
export const SatelitalHarvestRanchValue = 2;

export const ranchFieldsProperties = {
    [ManualHarvestRanchValue]: HarvestRanchFieldTypes.manual,
    [TelematicHarvestRanchValue]: HarvestRanchFieldTypes.telematic,
    [SatelitalHarvestRanchValue]: HarvestRanchFieldTypes.satelital
}

export type RanchFieldPriority = typeof ManualHarvestRanchValue | typeof TelematicHarvestRanchValue | typeof SatelitalHarvestRanchValue

export type HarvestEditableRanchFieldTypes = keyof typeof HarvestRanchFieldTypes | null;

export enum EditableHarvestRanchFields {
    ranking = "ranking",
    sowing_start = "sowing_start",
    resowing_start = "resowing_start",
    harvested_area = "harvested_area",
    resowing_area = "resowing_area",
}

export const insuranceCarrierEditableFields = ['sowing_start', 'resowing_start', 'resowing_area']


export interface editableField {
    telematic:  editableHarvestField,
    manual: editableHarvestField,
    satelital: editableHarvestField,
    priority: RanchFieldPriority,
    value: editableHarvestField,
    calculated_date?: string
}
export interface HarvestRanchEditableFields {
    [EditableHarvestRanchFields.ranking]: editableField,
    [EditableHarvestRanchFields.sowing_start]: editableField,
    [EditableHarvestRanchFields.resowing_start]: editableField,
    [EditableHarvestRanchFields.harvested_area]: editableField,
    [EditableHarvestRanchFields.resowing_area]: editableField,
}

export type HarvestRanchEditableFieldType = EditableHarvestRanchFields.ranking | 
EditableHarvestRanchFields.sowing_start | EditableHarvestRanchFields.resowing_start | EditableHarvestRanchFields.harvested_area | EditableHarvestRanchFields.resowing_area;

type editableFieldsChoices = {
    [key: string]: string
}

export interface editRanchEditableField {
    ranch_id: number,
    priority: RanchFieldPriority,
    [key:string]:any
}